export const apiVersionControlRoutes = {
  routeVersion: 'app/version/',
  routeLastVersion: 'app/version/byname/'
};
